import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M28 4L12 20m16-8V4h-8m-4 0H4v24h24V16" fill="none" />
  </Icon>
);
